import { SharedPackStatusController } from './shared-pack-status.controller'

const component = {
  templateUrl: '/core/components/shared-pack-status/shared-pack-status.html?$$REVISION$$',
  bindings: {
    status: '<'
  },
  controllerAs: '$ctrl',
  controller: SharedPackStatusController
}

export const sharedPackStatus = component
